module.exports = __webpack_public_path__ + "img/14.b4811b45.jpg";